import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import SiteJsonUnit from './SiteJsonUnit';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnits{
	constructor(props){
		const {list}=props;
		if(list === undefined || list === null)
			throwNotProvided('list');
		if(!Array.isArray(list))
			throwNotOfType('list', 'Array');
		this._list = list;
		this.getArray = this.getArray.bind(this);
		this.getPlotsArray = this.getPlotsArray.bind(this);
		this.getByUnitId = this.getByUnitId.bind(this);
		this.getPlotByNumber = this.getPlotByNumber.bind(this);
		this.getSelectedPlotsAsArray = this.getSelectedPlotsAsArray.bind(this);
	}
	getArray(){
		return this._list;
	}
	getPlotsArray(){
		let list = [];
		this._list.forEach(unit=>list=list.concat(unit.plots));
		return list;
	}
	getByUnitId(id){
		for(var i=0; i<this._list.length; i++){
			const unit = this._list[i];
			if(unit.id===id)return unit;
		}
		return null;
	}
	getFirstPlot(){
		return this._list[0].plots[0];
	}
	getPlotByNumber(number){
		return this.getPlotsArray().filter(plot=>plot.number===number)[0];
	}
	getSelectedPlotsAsArray(){
		return this.getPlotsArray().filter(plot=>plot.selected);
	}
	static fromJSON(jArray, houseTypes, currencyConfiguration){
		const units=[];
		for(var i=0; i<jArray.length; i++){
			try{
				const jObject = jArray[i];
				units.push(SiteJsonUnit.fromJSON(jObject, houseTypes, currencyConfiguration));
			}
			catch(err){
				throw new ParseError(`Could not parse Unit at index ${i}`, err);
			}
		}
		return new SiteJsonUnits({list:units});
	}
}